<template>  
  <div>
    <h3>Simulación de Cálculo de Fiscal Year</h3>
    <br>
    <p class="pa-2">
      <fs1-span>
        Antes de realizar algún cambio de año fiscal de manera oficial usted puede generar una planilla de BCEI o Repuestos Críticos e Importantes  a través del botón que aparece a continuación.
      </fs1-span>
    </p>	
    <div style="text-align: right">
      <v-btn color="primary" @click="dialog=true">
        <v-icon>insert_drive_file</v-icon>
        <span>Simulación de Planilla</span>
      </v-btn>
    </div>
		

		<v-dialog persistent v-model="dialog" width="700">
			<v-card class="pa-20 textAlignCenter">
				<h3>Simulación de Planilla por Año Fiscal</h3>
        <br>
        <p class="pa-2">
          <fs1-span>
            Para generar la planilla, debe elegir el año fiscal el cual desea simular y seleccionar el tipo de planilla: BCEI o Repuestos Críticos e Importantes
          </fs1-span>
        </p>
        <div>
          <v-select
            :placeholder="selectedYear ? undefined: 'Seleccionar el año'"
            v-model="selectedYear"
            :items="years"/>
        </div>
        <h4 class="text_align_left">Tipo de Planilla</h4>
        <div>
          <v-radio-group v-model="asset_type">
            <v-radio
              v-for="(d,i) in [{v:'ac',text:'BCEI'},{v:'sp',text:'Repuestos Críticos e Importantes'}]"
              :key="i"
              :label="`${d.text}`"
              :value="d.v"
            ></v-radio>
          </v-radio-group>
        </div>
        <div>
          <v-checkbox style="margin-top:0" v-model="f__include_simulations" label="Incluir simulaciones"/>
        </div>
        <!-- <div>
          <v-checkbox style="margin-top:0" v-model="f__ignore_bhp_share" label="Ignorar BHP Share en el cálculo (0,575)"/>
        </div> -->
        <br>
				<div>
					<v-btn color="secondary" @click="dialog = false">
						<span>Cerrar</span>
					</v-btn>
					<v-btn color="primary" @click="getSimulationsComputedValues" :disabled="!selectedYear || loading">
            <v-icon>insert_drive_file</v-icon>
						<span>Generar y Descargar Planilla</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>



  </div>
</template>

<script>
import {
  getSimulationsComputedValuesCriticalAsset,
  getSimulationsComputedValuesSparePart,
} from '@/requests/ac';

export default {
  data() {
    return {
      dialog:false,
      asset_type:'ac',
      selectedYear:null,
      f__include_simulations:false,
      /* f__ignore_bhp_share:false, */
      loading:false,
    };
  },
  computed: {
    years() {
      return this.$store.getters.fiscal_years.map(m => m.year).sort((a,b) => b - a);
    },
  },
  methods: {
    async getSimulationsComputedValues() {
      this.setProgress({show:true,message:'Generando...'});
      if(!await this.assignAccess()) return;
      const {f__include_simulations/* ,f__ignore_bhp_share */} = this;
      this.loading = true;
      (this.asset_type == 'ac'
        ?getSimulationsComputedValuesCriticalAsset
        :getSimulationsComputedValuesSparePart)
      ({simulation_fiscal_year:this.selectedYear,f__include_simulations/* ,f__ignore_bhp_share */})
        .then(r => this.setProgress({show:false}))
        .then(r => this.loading=false)
        .then(r => this.dialog = false)
        .catch(e => {
          this.getError(e);
          this.loading=false;
        });
    },
  },
};
</script>
